module.exports = __webpack_public_path__ + "img/020098.a2f7be99.png";